// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactus_main {
  display: flex;
  justify-content: center;
}

.contactus {
  background: var(--Color-Tokens-Background-Color-bg-strong-950, #0E121B);
  width: 95%;
padding: 0px 88px 0px 88px;
margin-top: 200px;
gap: 8px;
border-radius: 32px;

}


.contactus_outer{
display: flex;
justify-content: space-between;
/* padding: 80px 88px 80px 88px; */
gap: 8px;
border-radius: 32px;

}

.contactus_inner_left{
  padding: 80px 0px 80px 0px;
  vertical-align: middle;

}

.contactus_inner_left h2{
font-family: Sora;
font-size: 56px;
color: #FFFFFF;
font-weight: 600;
line-height: 72px;
text-align: left;

}

.contactus_inner_left p{
font-family: Sora;
font-size: 20px;
color: #E1E4EA;
font-weight: 400;
line-height: 28px;
letter-spacing: 0.15000000596046448px;
text-align: left;

}

.contactus_customimage_one{
  margin-top: -100px;
}



@media (max-width: 768px) {
  .contactus {
    padding: 0px 20px; /* Adjusted padding for mobile */
    margin-top: 100px; /* Adjusted margin for mobile */
  }
  
  .contactus_outer {
    flex-direction: column; /* Adjusted layout for mobile */
  }
  .contactus_customimage_one{
    overflow: hidden;
    width: 100%;
  }
  
  .contactus_inner_left {
    padding: 40px 0; /* Adjusted padding for mobile */
  }
  
  .contactus_inner_left h2 {
    text-align: center;
    font-family: Sora;
font-size: 38px;
font-weight: 600;
line-height: 46px;
text-align: center;

  }
  
  .contactus_inner_left p {
    text-align: center;
    font-family: Inter;
font-size: 18px;
font-weight: 400;
line-height: 28px;
text-align: center;

  }
  .dn_btn{
    font-family: Sora;
font-size: 16.55px;
font-weight: 400;
line-height: 20.68px;
letter-spacing: 0.2954545319080353px;
text-align: left;

    text-align: center;
    width: 100%;
  }
  
  .contactus_customimage_one {
    margin-top: 0; /* Reset margin for mobile */
  }
}
`, "",{"version":3,"sources":["webpack://./src/ContactUs/contactus.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,uEAAuE;EACvE,UAAU;AACZ,0BAA0B;AAC1B,iBAAiB;AACjB,QAAQ;AACR,mBAAmB;;AAEnB;;;AAGA;AACA,aAAa;AACb,8BAA8B;AAC9B,kCAAkC;AAClC,QAAQ;AACR,mBAAmB;;AAEnB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;;AAExB;;AAEA;AACA,iBAAiB;AACjB,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,iBAAiB;AACjB,gBAAgB;;AAEhB;;AAEA;AACA,iBAAiB;AACjB,eAAe;AACf,cAAc;AACd,gBAAgB;AAChB,iBAAiB;AACjB,qCAAqC;AACrC,gBAAgB;;AAEhB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA;EACE;IACE,iBAAiB,EAAE,gCAAgC;IACnD,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,sBAAsB,EAAE,+BAA+B;EACzD;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe,EAAE,gCAAgC;EACnD;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;AACrB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;EAEhB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;AACtB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,kBAAkB;;EAEhB;EACA;IACE,iBAAiB;AACrB,kBAAkB;AAClB,gBAAgB;AAChB,oBAAoB;AACpB,oCAAoC;AACpC,gBAAgB;;IAEZ,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,aAAa,EAAE,4BAA4B;EAC7C;AACF","sourcesContent":[".contactus_main {\n  display: flex;\n  justify-content: center;\n}\n\n.contactus {\n  background: var(--Color-Tokens-Background-Color-bg-strong-950, #0E121B);\n  width: 95%;\npadding: 0px 88px 0px 88px;\nmargin-top: 200px;\ngap: 8px;\nborder-radius: 32px;\n\n}\n\n\n.contactus_outer{\ndisplay: flex;\njustify-content: space-between;\n/* padding: 80px 88px 80px 88px; */\ngap: 8px;\nborder-radius: 32px;\n\n}\n\n.contactus_inner_left{\n  padding: 80px 0px 80px 0px;\n  vertical-align: middle;\n\n}\n\n.contactus_inner_left h2{\nfont-family: Sora;\nfont-size: 56px;\ncolor: #FFFFFF;\nfont-weight: 600;\nline-height: 72px;\ntext-align: left;\n\n}\n\n.contactus_inner_left p{\nfont-family: Sora;\nfont-size: 20px;\ncolor: #E1E4EA;\nfont-weight: 400;\nline-height: 28px;\nletter-spacing: 0.15000000596046448px;\ntext-align: left;\n\n}\n\n.contactus_customimage_one{\n  margin-top: -100px;\n}\n\n\n\n@media (max-width: 768px) {\n  .contactus {\n    padding: 0px 20px; /* Adjusted padding for mobile */\n    margin-top: 100px; /* Adjusted margin for mobile */\n  }\n  \n  .contactus_outer {\n    flex-direction: column; /* Adjusted layout for mobile */\n  }\n  .contactus_customimage_one{\n    overflow: hidden;\n    width: 100%;\n  }\n  \n  .contactus_inner_left {\n    padding: 40px 0; /* Adjusted padding for mobile */\n  }\n  \n  .contactus_inner_left h2 {\n    text-align: center;\n    font-family: Sora;\nfont-size: 38px;\nfont-weight: 600;\nline-height: 46px;\ntext-align: center;\n\n  }\n  \n  .contactus_inner_left p {\n    text-align: center;\n    font-family: Inter;\nfont-size: 18px;\nfont-weight: 400;\nline-height: 28px;\ntext-align: center;\n\n  }\n  .dn_btn{\n    font-family: Sora;\nfont-size: 16.55px;\nfont-weight: 400;\nline-height: 20.68px;\nletter-spacing: 0.2954545319080353px;\ntext-align: left;\n\n    text-align: center;\n    width: 100%;\n  }\n  \n  .contactus_customimage_one {\n    margin-top: 0; /* Reset margin for mobile */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
